export default __webpack_public_path__ + "static/media/cushion.4addd3b6.svg";